<template>
  <div>
    <v-sheet class="pa-8">
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="4"
          lg="4"
          xl="4"
          class="d-flex align-left">
          <p class="text-h5">
            สินค้าที่ไม่ได้จัดแสดง
          </p>
        </v-col>
        <v-spacer></v-spacer>
        <v-col
          cols="12"
          sm="12"
          md="4"
          lg="4"
          xl="4">
          <v-select
            v-model="query.warehouse"
            :class="$vuetify.breakpoint.xs ? '' : 'mr-3'"
            expanded
            :items="warehouses"
            label="Warehouse"
            dense
            item-text="name"
            item-value="id"
            outlined
            @change="() => fetchPaginate(true)"
          />
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="4"
          lg="4"
          xl="4">
          <date-picker-form
            v-model="query.createdAt"
            :clearable="true"
            dense
            placeholder="Created Date"
            name="Created Date"
            label="Created Date"
            outlined
            :rules="{ required: false }"
            @input="() => fetchPaginate(true)" />
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="items"
        hide-default-footer
        class="elevation-1"
        :loading="loading"
        loading-text="Loading... Please wait">
        <template v-slot:item.warehouse="{ item }">
          {{ item.warehouse.name || '-' }}
        </template>
        <template v-slot:item.status="{ item }">
          <p
            class="mb-0"
            :class="status[item.status].classStyle">
            {{ status[item.status].text }}
          </p>
        </template>
        <template v-slot:item.collection="{ item }">
          {{ item.collection ? item.collection.name : '-' }}
        </template>
        <template v-slot:item.createdAt="{ item }">
          {{ item.createdAt | dateTimeUserFormat }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            color="secondary"
            :disabled="item.status !== 'completed'"
            :to="{ name: 'noneDisplayProductDetail', params: { id: item.id } }">
            ผลลัพธ์
          </v-btn>
        </template>
      </v-data-table>
      <div class="text-center mt-4">
        <v-pagination
          v-model="query.page"
          color="secondary"
          :length="totalPages"
          @input="fetchPaginate()"></v-pagination>
      </div>
    </v-sheet>
  </div>
</template>

  <script>
  import RFIDProvider from '@/resources/RFIDProvider'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    components: {
    },
    data () {
      return {
        rfidProvider: new RFIDProvider(),
        items: [],
        totalPages: 0,
        totalItems: 0,
        loading: false,
        search: '',
        query: {
          sortBy: 'createdAt',
          sortOrder: 'desc',
          warehouse: '',
          createdAt: null,
          page: 1,
          limit: 10,
          search: '',
          status: ''
        },
        headers: [
          {
            text: 'Date',
            align: 'start',
            value: 'createdAt',
            sortable: false
          },
          {
            text: 'Status',
            align: 'center',
            value: 'status',
            sortable: false
          },
          {
            text: 'Collection',
            align: 'center',
            value: 'collection',
            sortable: false
          },
          {
            text: 'นับโดย',
            align: 'center',
            value: 'createdBy.email',
            sortable: false
          },
          {
            text: 'สาขา',
            align: 'center',
            value: 'warehouse.name',
            sortable: false
          },
          { text: 'Actions', align: 'left', value: 'actions', sortable: false }
        ],
        status: {
          pending: { text: 'PROCESSING', classStyle: 'indigo--text' },
          processing: { text: 'PROCESSING', classStyle: 'indigo--text' },
          completed: { text: 'COMPLETED', classStyle: 'success--text' },
          error: { text: 'ERROR', classStyle: 'red--text' }
        }
      }
    },
   computed: {
      ...mapGetters({
        mapWarehouse: 'Store/mapWarehouse'
      }),
      warehouses () {
        return [
          ...this.mapWarehouse.filter((warehouse) => warehouse.id !== 0)
        ]
      }
    },
    mounted () {
      this.parseQueryString()
      this.fetchPaginate()
    },
    methods: {
      ...mapActions({
        setModal: 'Components/setModal'
      }),
      parseQueryString () {
        const queryParams = new URLSearchParams(this.$route.query)
        this.query = {
          sortBy: queryParams.get('sortBy') || 'createdAt',
          sortOrder: queryParams.get('sortOrder') || 'desc',
          warehouse: parseInt(queryParams.get('warehouse')) || this.warehouses?.[0]?.id || '',
          page: parseInt(queryParams.get('page')) || 1,
          limit: parseInt(queryParams.get('limit')) || 10,
          search: queryParams.get('search') || '',
          status: queryParams.get('status') || '',
          createdAt: queryParams.get('createdAt') || null
        }
        this.search = queryParams.get('search') || ''
      },
      async fetchPaginate (isClear = false) {
        if (isClear) {
          this.query.page = 1
          this.items = []
          this.totalPages = 0
          this.totalItems = 0
        }
        try {
          this.loading = true
          const { data } = await this.rfidProvider.paginate(this.query)
          if (data) {
            this.items = data.results
            this.totalPages = data.totalPages
            this.totalItems = data.total
          }
        } catch (error) {
          console.error('fetchPaginate', error)
        }
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.query,
            createdAt: this.query.createdAt || ''
          }
        })
        this.loading = false
      },
      getStatus (status) {
        switch (status) {
          case 'pending': return { text: 'PENDING', color: 'yellow' }
          case 'processing': return { text: 'PROCESSING', color: 'indigo' }
          case 'completed': return { text: 'COMPLETED', color: 'success' }
          case 'error': return { text: 'ERROR', color: 'red' }
          default: return { text: '-', color: 'black' }
        }
      }
    }
  }
  </script>
